import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const settingsClientRoutes = [
  {
    id: 'settings-email-add',
    trackingName: 'Settings Email Add',
    path: 'web/view/settings/email/add',
    lazy: async () => ({
      Component: (await import('@cash-web/account-settings-feature-main')).JourneySettingsEmailAdd,
    }),
  },
  {
    id: 'settings-phone-number-add',
    trackingName: 'Settings Phone Number Add',
    path: 'web/view/settings/phone/add',
    lazy: async () => ({
      Component: (await import('@cash-web/account-settings-feature-main')).JourneySettingsPhoneNumberAdd,
    }),
  },
  {
    id: 'add-cashtag',
    trackingName: 'Add Cashtag',
    path: 'web/view/add-cashtag',
    lazy: async () => ({
      Component: (await import('@cash-web/account-settings-feature-main')).JourneyCashtag,
      props: { isEditing: false },
    }),
  },
  {
    id: 'edit-cashtag',
    trackingName: 'Edit Cashtag',
    path: 'web/view/edit-cashtag',
    lazy: async () => ({
      Component: (await import('@cash-web/account-settings-feature-main')).JourneyCashtag,
      props: { isEditing: true },
    }),
  },
  {
    id: 'remove-instrument',
    trackingName: 'Remove Instrument',
    path: 'web/view/settings/instrument/remove/:instrumentToken',
    lazy: async () => ({
      Component: (await import('@cash-web/account-settings-feature-main')).JourneyRemoveInstrument,
    }),
  },
  {
    id: 'settings-link-instrument',
    trackingName: 'Link Instrument',
    path: 'web/view/settings/instrument/link/:instrumentType',
    lazy: async () => ({
      Component: (await import('@cash-web/account-settings-feature-main')).JourneyLinkInstrument,
    }),
  },
  {
    id: 'settings-relink-instrument',
    trackingName: 'ReLink Instrument',
    path: 'web/view/settings/instrument/relink/:instrumentType',
    lazy: async () => ({
      Component: (await import('@cash-web/account-settings-feature-main')).JourneyReLinkInstrument,
    }),
  },
  {
    id: 'settings-view-limits',
    trackingName: 'View Limits',
    path: 'dl/view/limits',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/settings#limits')
    },
  },
  {
    id: 'settings-view-linked-bank-accounts',
    trackingName: 'View Linked Bank Accounts',
    path: 'dl/view/linked-bank-accounts',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/settings#linked-banks')
    },
  },
  {
    id: 'settings-view-pin',
    trackingName: 'View Pin',
    path: 'dl/view/pin',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/settings#security')
    },
  },
  {
    id: 'settings-view-address',
    trackingName: 'View Address',
    path: 'dl/view/address',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/settings')
    },
  },
  {
    id: 'settings-view-edit-profile',
    trackingName: 'View Edit Profile',
    path: 'dl/view/edit/profile',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/settings')
    },
  },
  {
    id: 'settings-view-profile',
    trackingName: 'View Profile',
    path: 'dl/view/profile',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/settings')
    },
  },
  {
    id: 'settings-view-profile-personal',
    trackingName: 'View Profile Personal',
    path: 'dl/view/profile-personal',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/settings')
    },
  },
  {
    id: 'settings-view-profile-customer',
    trackingName: 'View Profile Customer',
    path: 'dl/view/profile/customer/:customer_token',
    handle: {
      unsupported: true,
    },
  },
  {
    id: 'settings-view-profiles-switcher',
    trackingName: 'View Profiles Switcher',
    path: 'dl/view/profiles/switcher',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/settings/switch-account')
    },
  },
] as const satisfies JourneyRoute[]
